import React from 'react';
import { ThankYouConfirmation } from './thank-you/ThankYouConfirmation';
import { ThankYouDetails } from './thank-you/ThankYouDetails';
import { ThankYouReturn } from './thank-you/ThankYouReturn';
export function ThankYou() {
  return <div className="min-h-[70vh] bg-off-white flex items-center justify-center py-24" data-id="element-3493">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-3494">
        <ThankYouConfirmation data-id="element-3495" />
        <ThankYouDetails data-id="element-3496" />
        <ThankYouReturn data-id="element-3497" />
      </div>
    </div>;
}